if (!customElements.get('vnhshoppable-layout-slider')) {
 class VananShoppableSlider extends HTMLElement {
  connectedCallback() {
   if(this.initialized) return;
   this.initialized=true;
   this.onVisibility=()=>{if(document.hidden)this.querySelectorAll('video').forEach(v=>v.pause());};
   document.addEventListener('visibilitychange',this.onVisibility);
   this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.init();this.observer.disconnect();}},{rootMargin:'150px'});
   this.observer.observe(this);
  }
  init(){
   if(this.swiper)return;
   const el=this.querySelector('.swiper-vnhshoppable-slider');
   if(!el||typeof Swiper==='undefined')return;
   this.swiper=new Swiper(el,{autoplay:false,spaceBetween:16,slidesPerView:1.3,navigation:{nextEl:this.querySelector('.swiper-button--next'),prevEl:this.querySelector('.swiper-button--prev')},breakpoints:{750:{spaceBetween:24,slidesPerView:2.4},990:{spaceBetween:28,slidesPerView:3.3},1200:{spaceBetween:32,slidesPerView:3.8}}});
   const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.videoObserver=new IntersectionObserver(entries=>entries.forEach(({target:v,isIntersecting})=>{
    if(isIntersecting&&!reduce&&!document.hidden){v.muted=true;v.playsInline=true;const play=v.play();if(play)play.catch(()=>{v.controls=true;});}else{v.pause();if(reduce)v.controls=true;}
   }),{threshold:.55});
   this.querySelectorAll('video').forEach(v=>this.videoObserver.observe(v));
  }
  open(event,index,id){
   const drawer=document.querySelector(`vnhshoppable-drawer.vnhshoppable-drawer--${id}`);
   if(drawer)drawer.openWithIndex(event,index);
  }
  disconnectedCallback(){this.observer?.disconnect();this.videoObserver?.disconnect();this.swiper?.destroy(true,true);this.swiper=null;this.initialized=false;document.removeEventListener('visibilitychange',this.onVisibility);}
 }
 customElements.define('vnhshoppable-layout-slider',VananShoppableSlider);
}